import { authorizedInstance } from "../config/axios"

export const getErrorCodesMappings = async ({ page, limit, filters }) => {
  const query = new URLSearchParams({
    page,
    limit,
    ...filters,
  })

  const response = await authorizedInstance.get(
    `/error-codes-mappings?${query}`
  )
  return response.data
}

export const getErrorCodesMapping = async (errorId) => {
  const response = await authorizedInstance.get(
    `/error-codes-mappings/${errorId}`
  )
  return response.data
}

export const createErrorCodesMapping = async (data) => {
  const response = await authorizedInstance.post("/error-codes-mappings", data)
  return response.data
}

export const updateErrorCodesMapping = async (errorId, data) => {
  const response = await authorizedInstance.put(
    `/error-codes-mappings/${errorId}`,
    data
  )
  return response.data
}

export const deleteErrorCodesMapping = async (errorId) => {
  const response = await authorizedInstance.delete(
    `/error-codes-mappings/${errorId}`
  )
  return response.data
}
